"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartLineUpdateInput } from "@shopify/hydrogen-react/storefront-api-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Usable } from "react";
import { HiOutlineMinus, HiOutlinePlus } from "react-icons/hi2";
import type { ResolvedIntlConfig } from "react-intl";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Button } from "@repo/components/atoms/shadcn/button";
import { LoadingDots } from "@repo/components/atoms/loading-dots";
import { BaseCartLine_Fragment } from "#/graphql/shopify-storefront/fragments";
import { CART_QUERY_KEY } from "@repo/constants";
import { CartLinesUpdate_Mutation } from "#/graphql/shopify-storefront/mutations";
import { fetcherShopifyStorefront, readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useGetIntl } from "@repo/i18n/intl/client";
import { cn } from "@repo/lib";
export function EditItemQuantityButton(t0) {
  const $ = _c(36);
  const {
    cartId,
    className,
    dictionaryPromise,
    baseCartLineFragment,
    lang,
    type
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let t2;
  if ($[3] !== baseCartLineFragment) {
    t2 = readFragmentShopifyStorefront(BaseCartLine_Fragment, baseCartLineFragment);
    $[3] = baseCartLineFragment;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const baseCartLine = t2;
  const t3 = type === "plus" ? baseCartLine.quantity + 1 : baseCartLine.quantity - 1;
  let t4;
  if ($[5] !== baseCartLine.id || $[6] !== baseCartLine.merchandise.id || $[7] !== t3) {
    t4 = {
      id: baseCartLine.id,
      merchandiseId: baseCartLine.merchandise.id,
      quantity: t3
    };
    $[5] = baseCartLine.id;
    $[6] = baseCartLine.merchandise.id;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const payload = t4 satisfies CartLineUpdateInput;
  const shopifyQueryClient = useQueryClient();
  let t5;
  if ($[9] !== cartId || $[10] !== shopifyQueryClient) {
    t5 = {
      mutationFn: _temp,
      onSuccess: () => {
        const queryKey = [CART_QUERY_KEY, cartId];
        shopifyQueryClient.invalidateQueries({
          queryKey
        });
        window.dispatchEvent(new Event("cart-updated"));
      }
    };
    $[9] = cartId;
    $[10] = shopifyQueryClient;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    isPending,
    mutate,
    status
  } = useMutation(t5);
  let t6;
  if ($[12] !== intl || $[13] !== type) {
    t6 = type === "plus" ? intl.formatMessage({
      defaultMessage: "Increase",
      description: "Increase",
      id: "bXH4Je"
    }) : intl.formatMessage({
      defaultMessage: "Decrease",
      description: "Decrease",
      id: "wpucUJ"
    });
    $[12] = intl;
    $[13] = type;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = type === "minus";
  let t8;
  if ($[15] !== className || $[16] !== isPending || $[17] !== t7) {
    t8 = cn(className, {
      "cursor-not-allowed": isPending,
      "ms-auto": t7
    });
    $[15] = className;
    $[16] = isPending;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== cartId || $[20] !== isPending || $[21] !== mutate || $[22] !== payload) {
    t9 = e => {
      if (isPending) {
        e.preventDefault();
      }
      mutate({
        cartId,
        lines: [payload]
      });
    };
    $[19] = cartId;
    $[20] = isPending;
    $[21] = mutate;
    $[22] = payload;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== isPending || $[25] !== type) {
    t10 = isPending ? <LoadingDots /> : type === "plus" ? <HiOutlinePlus className="h-4 w-4 dark:text-neutral-500" /> : <HiOutlineMinus className="h-4 w-4 dark:text-neutral-500" />;
    $[24] = isPending;
    $[25] = type;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== status) {
    t11 = <span aria-live="polite" className="sr-only" role="status">{status}</span>;
    $[27] = status;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== isPending || $[30] !== t10 || $[31] !== t11 || $[32] !== t6 || $[33] !== t8 || $[34] !== t9) {
    t12 = <Button aria-label={t6} aria-disabled={isPending} className={t8} onClick={t9} variant="ghost">{t10}{t11}</Button>;
    $[29] = isPending;
    $[30] = t10;
    $[31] = t11;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}
function _temp(variables) {
  return fetcherShopifyStorefront(CartLinesUpdate_Mutation, variables);
}